import { render, staticRenderFns } from "./WorkView.vue?vue&type=template&id=bcdc2348&"
import script from "./WorkView.vue?vue&type=script&lang=js&"
export * from "./WorkView.vue?vue&type=script&lang=js&"
import style0 from "./WorkView.vue?vue&type=style&index=0&id=bcdc2348&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports